import { Badge, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

import type { TItemCardStatus } from '@modules/items/types/folders.types';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: tokens.spacingHorizontalXS,
    height: '16px',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  badge: {
    width: 'auto',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    flexShrink: 1,
  },
  label: {
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});

type TProps = {
  cardStatus?: TItemCardStatus;
  className?: string;
};

const formatStatusCount = (count: number, label: string): string =>
  `${count.toLocaleString()} ${label}${count === 1 ? '' : 's'}`;

const ItemCardStatusBadges = ({ cardStatus, className }: TProps) => {
  const classes = useStyles();
  const openApprovals = cardStatus?.openApprovals ?? 0;
  const overduePeriodicReviews = cardStatus?.overduePeriodicReviews ?? 0;

  return (
    <div className={mergeClasses(classes.root, className)}>
      {openApprovals > 0 && (
        <Badge appearance="tint" color="warning" size="small" className={classes.badge}>
          <span className={classes.label}>{formatStatusCount(openApprovals, 'open approval')}</span>
        </Badge>
      )}
      {overduePeriodicReviews > 0 && (
        <Badge appearance="tint" color="danger" size="small" className={classes.badge}>
          <span className={classes.label}>{formatStatusCount(overduePeriodicReviews, 'overdue periodic review')}</span>
        </Badge>
      )}
    </div>
  );
};

export default ItemCardStatusBadges;
